import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TesteDirective } from './teste.directive';



@NgModule({
  declarations: [TesteDirective],
  imports: [
    CommonModule
  ],
  exports:[
    TesteDirective
  ]
})
export class DirectsModule { }
